module.exports = __webpack_public_path__ + "img/res06.3626c4d2.png";